export const CellTypes = {
    BOX: 'box',
  }